// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// This file is used for STAGING/TESTING environment
// For local development, copy environment.local.ts.template to environment.local.ts
// and use: npm run start:local

export const environment = {
  production: false,
  environmentVersion: 'staging',
  useLocalDevTokens: false, // Staging uses full OAuth flow
  appUrl: 'https://staging.ritning.harjedalskok.se',
  oauthLoginUrl: 'https://testrapport.harjedalskok.se/oauth/authorize',
  oauthTokenUrl: 'https://testrapport.harjedalskok.se/oauth/token',
  oauthCallbackUrl: 'https://staging.ritning.harjedalskok.se/oauth/callback',
  oauthVerifyToken: 'https://testrapport.harjedalskok.se/oauth/verifytoken',
  oauthRefreshToken: 'https://testrapport.harjedalskok.se/oauth/refreshtoken',
  validationUrl: 'https://testrapport.harjedalskok.se/drawing/validations',
  quoteUrl: 'https://testrapport.harjedalskok.se/drawing/quote/',
  userSettings: 'https://testrapport.harjedalskok.se/drawing/usersettings/',
  productOrderUrl: 'https://testrapport.harjedalskok.se/drawing/productorder/',
  autoUpdateProductOrderUrl:
    'https://testrapport.harjedalskok.se/drawing/autoupdateproductorder/',
  updateProductOrderUrl:
    'https://testrapport.harjedalskok.se/drawing/updateproductorder/',
  showProductOrder:
    'https://testrapport.harjedalskok.se/products/showproductorder/',
  products: 'https://testrapport.harjedalskok.se/drawing/products',
  productFile: 'https://testrapport.harjedalskok.se/drawing/productfile/',
  pdfUpload: 'https://testrapport.harjedalskok.se/drawing/uploadpdf',
  log: 'https://testrapport.harjedalskok.se/drawing/log',
  oauthClientId: 'drawing',
  secret: 'secret',

  // Development tokens - only used when useLocalDevTokens is true
  devAccessToken: '',
  devRefreshToken: '',
  devOrderId: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
